module.exports = __webpack_public_path__ + "static/media/star.b489e613.svg";